import i18next from "i18next";
import OsmMap from "../StaffGPSUsers/OsmMap";
import { useContext, useEffect, useState } from "react";
import { Get, handleError } from "../../../utils/fetch.util";
import { UserContext } from "../../../contexts/user.context";

interface SiteData {
  site_id: number;
  site_name: string;
  logo_url: string;
  site_url: string | null;
  site_serial: string;
  createdAt: string;
  updatedAt: string;
  qrcode: string;
  qrcode_url: string;
  site_locations: any;
  deleted: boolean;
  site_index: number;
  deleted_sector_id: number | null;
  asdc_client_sector_id: number;
  client_id: number;
  country_id: number;
  points?: number;
}

interface StaffGPSUsersEditMapProps {
  isAdmin?: boolean;
  selectedSite?: SiteData | null;
}

export default function StaffGPSUsersEditMap({ isAdmin = false, selectedSite = null }: StaffGPSUsersEditMapProps) {
  const [allUsers, setAllUsers] = useState([]);
  const { getValidToken } = useContext(UserContext);

  const getLastSeen = (updatedAt: Date | number | string) => {
    const currentTime = new Date();
    const updatedAtTime = new Date(updatedAt);
    const timeDifference = currentTime.getTime() - updatedAtTime.getTime();

    const minutes = Math.floor(timeDifference / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (i18next.language === "en") {
      if (minutes < 1) {
        return "Just now";
      } else if (minutes < 60) {
        return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
      } else if (hours < 24) {
        return `${hours} hour${hours > 1 ? "s" : ""} ago`;
      } else {
        return `${days} day${days > 1 ? "s" : ""} ago`;
      }
    }
    if (i18next.language === "ar") {
      if (minutes < 1) {
        return "الآن";
      } else if (minutes < 60) {
        return `منذ ${minutes} دقيقة`;
      } else if (hours < 24) {
        return `منذ ${hours} ساعة`;
      } else {
        return `منذ ${days} يوم`;
      }
    }
  };

  useEffect(() => {
    // Only fetch users if not in admin mode
    if (!isAdmin) {
      const getUsers = async () => {
        const res = await Get(
          `asdc-client-user/get-all-online-users`,
          getValidToken(),
        );
        if (res.error || !res.data) {
          handleError(res);
        }

        setAllUsers(
          res.data
            .filter((item: any) => item.asdc_client_user_type === "mobile")
            .sort((a: any, b: any) => {
              a = new Date(a.updatedAt);
              b = new Date(b.updatedAt);
              return a > b ? -1 : a < b ? 1 : 0;
            }),
        );
      };

      getUsers();
    }
  }, [getValidToken, isAdmin]);

  return <OsmMap users={allUsers} getLastSeen={getLastSeen} selectedSite={selectedSite} />;
}
